const defaultEventOptions = {
  bubbles: true,
  composed: true,
  cancelable: false,
  detail: void 0
};
const customEvent = (event, eventOptions) => {
  const options = {
    ...defaultEventOptions,
    ...eventOptions
  };
  return typeof event === "string" ? new CustomEvent(event, options) : new CustomEvent(event.name, { ...options, detail: event.payload });
};
const withEventEmitter = (BaseElement) => class EventEmitter extends BaseElement {
  // Define method on base class
  emit(event, eventOptions) {
    if (this && this.dispatchEvent) {
      const evt = customEvent(event, eventOptions);
      this.dispatchEvent(evt);
    }
  }
};
export {
  customEvent,
  withEventEmitter
};
